import {Injectable} from '@angular/core';
import {ApiService} from '@common-lib';
import {map} from 'rxjs/operators';

@Injectable()
export class SettingsService {

    constructor(private api: ApiService) {
    }

    getSettings() {
        return this.api.get('/admin/settings').pipe(map(({result}) => result));
    }

    saveSettings(data) {
        return this.api.put('/admin/settings', data).pipe(map(({result}) => result));
    }

    uploadFile(fileToUpload: File, pathToFolder) {
        const apiPath = '/filemanager/image-package';
        const formData: FormData = new FormData();
        formData.append('file', fileToUpload, fileToUpload.name);
        return this.api.uploadFile(formData, pathToFolder, fileToUpload.name, apiPath);
    }

    uploadExistingPackage(id) {
        const apiPath = '/filemanager/image-package';
        const pathToFolder = 'assets';
        return this.api.post(apiPath, {}, { id: id.toString(), pathToFolder });
    }

    loadPublishVersionsList() {
        return this.api.get('/admin/publish').pipe(map(({result}) => result));
    }

    publish(version: string) {
        return this.api.post('/admin/publish', {
            version
        }).pipe(map(({result}) => result));
    }

}



// WEBPACK FOOTER //
// ./src/app/pages-services/settings.service.ts